import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import RequireSignupFinishedMiddleware from 'middlewares/RequireSignupFinishedMiddleware'
import RequirePhysicianOrAncillaryOrDemoMiddleware from 'middlewares/RequirePhysicianOrAncillaryOrDemoMiddleware'

export default [
    ...['received', 'made'].map((type) => ({
        path: `/referrals/temporary/${type}/:id`,
        name: `referrals.${type}.temporary.show`,
        view: 'referrals/temporary-referrals/ReferralTemporaryShow',
        default: { params: { type } },
        middlewares: [RequireSignupFinishedMiddleware, RequirePhysicianOrAncillaryOrDemoMiddleware, RequireUserMiddleware],
    })),
]
